

import auth from '../../../common/mixins/auth'
import alertWeb from '../../../common/mixins/alertWeb'

export default {
  name: 'Register',
  mixins: [auth, alertWeb]
}
